import { observer } from "mobx-react-lite";
import React from "react";
import Link from "@mui/material/Link";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import i18nStore from "../../i18n/store";
import { loginPath } from "../../routes/paths";

const SuccessRegisteredMsg = observer(() => {
    const translations = i18nStore.getTranslations;
    const navigate = useNavigate();
    const location = useLocation();
    const email: string = location.state?.email || "";

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography component="h1" variant="h5" sx={{ mb: 4 }}>
                    {translations.finishSignUp.finishRegistration}
                </Typography>

                <Typography variant="subtitle1" component="p">
                    {translations.finishSignUp.emailWasSend.format(email)}
                </Typography>

                <Typography variant="subtitle1" component="p">
                    {translations.finishSignUp.returnBackToLoginPage1}&nbsp;
                    <Link
                        href={loginPath}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigate(loginPath);
                        }}
                        sx={{
                            "&:hover": {
                                cursor: "pointer",
                            },
                        }}
                    >
                        {translations.finishSignUp.returnBackToLoginPage2}
                    </Link>
                    .
                </Typography>
            </Box>
        </Container>
    );
});

export default SuccessRegisteredMsg;
